<template>
  <div class="page-table">
    <el-table
      v-loading="loading"
      :data="dataSource"
      border
      stripe
    >
      <el-table-column
        prop="firmName"
        label="商行"
        width="80"
      />
      <el-table-column
        prop="bigCategoryName"
        label="大类"
        width="100"
      />
      <el-table-column
        prop="midCategoryName"
        label="中类"
        width="100"
      />
      <el-table-column
        prop="smallCategoryName"
        label="小类"
        width="120"
      />
      <el-table-column
        prop="breedName"
        label="品项"
      />
      <el-table-column
        prop="countryName"
        label="国家"
        width="100"
      />
      <el-table-column
        prop="provinceName"
        label="省份"
        width="100"
      />
      <el-table-column
        prop="cityName"
        label="市县"
        width="100"
      />
      <el-table-column
        prop="qualityName"
        label="品规属性"
        width="150"
      />
      <el-table-column
        prop="qualityValue"
        label="品规"
        width="120"
      />
      <el-table-column
        prop="cooperateFlag"
        label="是否有基地合作"
        width="120"
      >
        <template slot-scope="scope">
          {{ scope.row.cooperateFlag ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        prop="yield"
        label="产量"
        width="100"
      />
      <el-table-column
        prop="plantingScale"
        label="种植规模"
        width="100"
      />
      <el-table-column
        prop="varietalCharacter"
        label="产地品种特色"
        width="150"
        show-overflow-tooltip
      />
      <el-table-column
        label="产地上市时间"
        width="120"
      >
        <el-table-column
          v-for="(item, i) in monthList"
          :key="i"
          :prop="item"
          :label="item"
          width="50"
        >
          <template slot-scope="scope">
            {{ scope.row[`onSale${i+1}`] ? '是' : '否' }}
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next"
      :total="page.totalCount"
      :page-size="page.numPerPage"
      :current-page="page.pageNum"
      @current-change="onCurrentChange"
    />
  </div>
</template>
<script>
export default {
  props: ['loading'],
  data() {
    return {
      monthList: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12']
    }
  },
  computed: {
    dataSource() {
      const dataSource = this.$store.state.product.freshOriginInfo.retrieve.results
      if (dataSource) {
        this.$emit('update:loading', false)
      }
      return dataSource || []
    },
    page() {
      return this.$store.state.product.freshOriginInfo.retrieve.page || []
    }
  },
  methods: {
    onCurrentChange(e) {
      this.$emit('onCurrentChange', e)
    }
  }
}
</script>
<style lang="less" >
    .page-table{
        .el-table thead  th{
            background: #94a49b;
            color: #fff;
            font-size: 13px;
            text-align: center;
            /*border: 0;*/

        }
        .el-table th,  .el-table td {
            padding: 8px 0
        }
        .el-pagination {
            text-align: center;
            margin: 20px 0;
        }
    }
</style>
